import { apiFetch, apiPost } from "../_helpers";

export const purchasesService = {
  getAll,
  get,
  addPosTransaction,
};

function getAll(params) {
  let str = Object.entries(params)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");

  return apiFetch("transactions/?" + str);
}

function get(pk) {
  return apiFetch("transactions/" + pk + "/");
}

function addPosTransaction(payload) {
  return apiPost("addpostransaction/", payload);
}
